import { render } from "./_admin.vue?vue&type=template&id=eb8f8146&lang=pug"
import script from "./_admin.vue?vue&type=script&lang=js"
export * from "./_admin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__